<div>
    @switch (warning().type) {
        @case (orderWarningType.ORDER) {
            @if (order().pendingSpecial || showInstructions()) {
                <div class="order-warning-container" [ngStyle]="{ borderRadius: borderRadius() }">
                    <cwo-icon class="error-icon" [name]="iconNameType.error" [size]="'1rem'" />
                    <div class="text-group">
                        <span class="warning-text">{{warning().text}}</span>
                        <button class="instruction-button" (click)="handleInstruction()">
                            <span class="instruction-text">{{'shared_components.order_warning.instructions' | transloco}}</span>
                            <cwo-icon class="arrow-icon" [name]="iconNameType.arrow" [size]="'0.875rem'"/>
                        </button>
                    </div>
                </div>
            } @else {
                <div class="order-warning-container" [ngStyle]="{ borderRadius: borderRadius() }">
                    <cwo-icon class="error-icon" [name]="iconNameType.error" [size]="'1rem'" />
                    <div class="text-group">
                        <span class="warning-text">{{warning().text}}</span>
                    </div>
                </div>
            }
        }

        @case (orderWarningType.SPECIAL) {
            <div class="order-warning-container" [ngStyle]="{ borderRadius: borderRadius() }">
                <cwo-icon class="error-icon" [name]="iconNameType.error" [size]="'1rem'" />
                <div class="text-group">
                    @if (warning().special?.warnings?.length) {
                        @for (singleSpecialWarning of warning().special?.warnings; track $index) {
                            <span class="warning-text">{{ singleSpecialWarning.length ? singleSpecialWarning : warning().special?.special }}</span>
                        }
                        <button class="instruction-button" (click)="handleInstruction()">
                            <span class="instruction-text">{{'shared_components.order_warning.instructions' | transloco}}</span>
                            <cwo-icon class="arrow-icon" [name]="iconNameType.arrow" [size]="'0.875rem'"/>
                        </button>
                    }
                </div>
            </div>
        }

        @case (orderWarningType.MISSING_ORDER) {
            <div class="order-warning-container" [ngStyle]="{ borderRadius: borderRadius() }">
                <cwo-icon class="error-icon" [name]="iconNameType.error" [size]="'1rem'" />
                <div class="text-group">
                    <span class="warning-text">{{warning().text}}</span>
                    <button class="instruction-button" (click)="handleInstruction()">
                        <span class="instruction-text">{{'shared_components.order_warning.order_details' | transloco}}</span>
                        <cwo-icon class="arrow-icon" [name]="iconNameType.arrow" [size]="'0.875rem'"/>
                    </button>
                </div>
            </div>
        }
    }
</div>